import { render, staticRenderFns } from "./bottomWidge.vue?vue&type=template&id=3c52991a&scoped=true"
import script from "./bottomWidge.vue?vue&type=script&lang=js"
export * from "./bottomWidge.vue?vue&type=script&lang=js"
import style0 from "./bottomWidge.vue?vue&type=style&index=0&id=3c52991a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c52991a",
  null
  
)

export default component.exports